import { Link, NavLink } from 'react-router-dom';
import Navigation from './Navigation';
import { IoArrowBackCircleSharp } from 'react-icons/io5';

const Sidebar = ({ setIsOpen }) => {
  return (
    <aside className="text-white flex flex-col w-screen md:w-96 relative   h-full pt-4  bg-black border-r-[1px] border-[#87ceeb]  z-50 px-4 pb-4 ">
      <nav className="flex flex-col  navigationChat h-full gap-2">
        <Link
          to="https://agntacademy.ai/"
          className="t px-4 text-lg mb-8 flex gap-4 py-2 max-w-[200px]"
        >
          <IoArrowBackCircleSharp size={30} /> Back to site
        </Link>
        <Link
          to="/"
          className="  px-4 text-lg mb-5 py-2 border-[1px] border-blue-300 rounded-lg "
          onClick={() => setIsOpen(false)}
        >
          Home
        </Link>
        <NavLink
          to="agent_training"
          className=" px-4 text-lg py-2 border-[1px] border-blue-300 rounded-lg "
          onClick={() => setIsOpen(false)}
        >
          <span>Agent Training</span>
        </NavLink>
        <NavLink
          to="integration_with_local_and_internationa_labo_markets"
          className="  px-4 text-lg py-2  select-none  opacity-65 pointer-events-none border-[1px] border-blue-200 rounded-lg "
        >
          <span>
            Integration with local and international labor markets (soon)
          </span>
        </NavLink>
        <NavLink
          to="verification_and_security"
          className=" px-4 text-lg py-2 select-none  opacity-65 pointer-events-none border-[1px] border-blue-200 rounded-lg "
        >
          <span>Verification and Security (soon)</span>
        </NavLink>
      </nav>
      <Navigation />
    </aside>
  );
};

export default Sidebar;
